// Google Map Customization
(function(){
	var map;

	map = new GMaps({
		el: '#google_map',
		lat: 44.977991,
		lng: -93.268228,
		scrollwheel:false,
		zoom: 15,
		zoomControl : true,
		zoomControlOptions : {
			position: google.maps.ControlPosition.RIGHT_BOTTOM
		},
		panControl : false,
		streetViewControl : false,
		mapTypeControl: false,
		overviewMapControl: false,
		clickable: false
	});

	var bbdoIcon = {
		url: '/wp-content/themes/bbdompls_v2/_a/images/map_marker.png',
		scaledSize: new google.maps.Size(125,60),
		anchor: new google.maps.Point(60,35)
	};
	map.addMarker({
		lat: 44.977991,
		lng: -93.268228,
		icon: bbdoIcon,
		animation: google.maps.Animation.DROP,
	});


	var styles = [{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"stylers":[{"hue":"#00aaff"},{"saturation":-100},{"gamma":2.15},{"lightness":12}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":24}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":57}]}];

	map.addStyle({
		styledMapName: "BBDO Map",
		styles: styles,
		mapTypeId: "map_style"
	});

	map.setStyle("map_style");
}());
